module.exports = __webpack_public_path__ + "img/user-avatar.0a820b29.svg";